export function filterByKeywords(
  options: string[],
  keywords: string | string[],
  current: string | string[] = [],
): string[] {
  const needles = (Array.isArray(keywords) ? keywords : [keywords]).map((value) => value.toLowerCase())
  const selected = new Set(Array.isArray(current) ? current : [current])
  const matches = options.filter((option) =>
    needles.every((needle) => option.toLowerCase().includes(needle)),
  )
  const base = matches.length ? matches : options
  const preserved = options.filter((option) => selected.has(option) && !base.includes(option))
  const result = [...preserved, ...base]
  if (options.includes('None')) return ['None', ...result.filter((item) => item !== 'None')]
  return result
}

export function filterBySearch(
  options: string[],
  query: string,
  current: string | string[] = [],
): string[] {
  const needle = query.trim().toLowerCase()
  const selected = new Set(Array.isArray(current) ? current : [current])
  const matches = needle
    ? options.filter((option) => option.toLowerCase().includes(needle) || selected.has(option))
    : [...options]
  if (options.includes('None')) return ['None', ...matches.filter((item) => item !== 'None')]
  return matches
}
